import { render, staticRenderFns } from "./komersial.vue?vue&type=template&id=85919e18&"
import script from "./komersial.vue?vue&type=script&lang=js&"
export * from "./komersial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports